export interface FilterOutSpecializationsParams {
  specializations: string[]
  primaryFocus: string | undefined
}

export const removeSpecializationMatchingPrimaryFocus = ({
  specializations,
  primaryFocus
}: FilterOutSpecializationsParams): string[] => {
  if (!primaryFocus) return specializations

  return specializations.filter((spec) => spec !== primaryFocus)
}
